const FastCollectData = [
  // {
  //   title: '中国政府网_要闻采集',
  //   logoImg: '/static/img/collectGov',
  //   type: 'gov',
  //   rule: '采集中国政府网新闻要闻数据，包含标题、链接、时间、内容、来源等字段。 采集地址：http://sousuo.gov.cn/column/31421/0.htm',
  //   modelType: 1,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '文章链接',
  //       key: 'link',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '时间',
  //       key: 'createTime',
  //       fieldIds: 3
  //     },
  //     {
  //       name: '来源',
  //       key: 'source',
  //       fieldIds: 4
  //     },
  //     {
  //       name: '内容',
  //       key: 'content',
  //       fieldIds: 5
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: '创新指数何以创新高',
  //       link: 'http://www.gov.cn/xinwen/index.htm',
  //       createTime: '2019-11-01 09:00',
  //       source: '人民日报',
  //       content: '新华社北京11月8日电（记者 李宣良、张玉清）七十载光辉岁月，九万里风鹏正举。在人民空军成立70周年之际，中共中央总书记、国家主席、中央军委主席习近平8日出席庆祝空军成立70周年主题活动，代表党中央和中央军委，对空军成立70周年表示热烈祝贺，向空军全体官兵致以诚挚问候。'
  //     }
  //   ]
  // },
  // {
  //   title: '百度搜索关键词列表信息采集',
  //   logoImg: 'static/img/collectBaidu',
  //   type: 'baidu',
  //   rule: '按照关键词，采集百度的搜索结果。字段标题、链接、描述、域名。',
  //   modelType: 2,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '结果链接',
  //       key: 'link',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '描述',
  //       key: 'describe',
  //       fieldIds: 6
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: 'JEECMS官网-JAVA网站内容管理系统',
  //       link: 'https://www.baidu.com/s?tn=site5566&ch=1&word=JEECMS',
  //       describe: 'JEECMS官网－JAVA网站内容管理系统|开源java cms系统,jsp cms网站管理',
  //       targetLink: 'http://www.jeecms.com/'
  //     }
  //   ]
  // },
  {
    title: '采集指定用户所有微博内容',
    logoImg: 'static/img/collectWeibo',
    modelType: 3,
    type: 'weibo',
    rule: '根据微博用户UID，采集该用户发布的所有微博数据。 包括用户、发布时间、内容、图片、来源、转发、评论等。',
    tip: '打开手机版微博，点击用户的微博主页，查看网址为：https://m.weibo.cn/u/2927573465， 后面的“2927573465”为该用户的UID。',
    tableTile: [
      {
        name: '用户',
        key: 'username',
        fieldIds: 1
      },
      {
        name: '时间',
        key: 'date',
        fieldIds: 3
      },
      {
        name: '内容',
        key: 'content',
        fieldIds: 5
      },
      {
        name: '图片',
        key: 'img',
        fieldIds: 7
      },
      {
        name: '来源',
        key: 'source',
        fieldIds: 4
      },
      {
        name: '转发数',
        key: 'forward',
        fieldIds: 8
      },
      {
        name: '评论数',
        key: 'comment',
        fieldIds: 9
      },
      {
        name: '点赞数',
        key: 'up',
        fieldIds: 10
      }
    ],
    exampleList: [
      {
        username: '央视新闻',
        date: '20分钟前',
        content: '习近平在出席庆祝空军成立70周年主题活动时强调 牢记初心使命 发扬光荣传统 勇于创新超越 把人民空军全面建成世界一流空军',
        img: 'https://wx1.sinaimg.cn/',
        source: '微博 weibo.com',
        forward: '35',
        comment: '51',
        up: '366'
      }
    ]
  },
  // {
  //   title: '文旅要闻',
  //   logoImg: '/static/img/logo',
  //   type: 'gov',
  //   rule: '采集文旅要闻数据，包含标题、时间、内容、来源等字段。 采集地址：http://www.whyn.gov.cn/list/index/1/1',
  //   modelType: 11,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '时间',
  //       key: 'createTime',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '来源',
  //       key: 'source',
  //       fieldIds: 3
  //     },
  //     {
  //       name: '内容',
  //       key: 'content',
  //       fieldIds: 4
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: '创新指数何以创新高',
  //       link: 'http://www.whyn.gov.cn/list/index/1/1',
  //       createTime: '2019-11-01 09:00',
  //       source: '人民日报',
  //       content: '新华社北京11月8日电（记者 李宣良、张玉清）七十载光辉岁月，九万里风鹏正举。在人民空军成立70周年之际，中共中央总书记、国家主席、中央军委主席习近平8日出席庆祝空军成立70周年主题活动，代表党中央和中央军委，对空军成立70周年表示热烈祝贺，向空军全体官兵致以诚挚问候。'
  //     }
  //   ]
  // },
  // {
  //   title: '云南动态',
  //   logoImg: '/static/img/logo',
  //   type: 'gov',
  //   rule: '采集云南动态数据，包含标题、时间、内容、来源等字段。 采集地址：http://www.ynta.gov.cn/Category_1048/Index_1.aspx',
  //   modelType: 12,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '时间',
  //       key: 'createTime',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '来源',
  //       key: 'source',
  //       fieldIds: 3
  //     },
  //     {
  //       name: '内容',
  //       key: 'content',
  //       fieldIds: 4
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: '创新指数何以创新高',
  //       link: 'http://www.whyn.gov.cn/list/index/1/1',
  //       createTime: '2019-11-01 09:00',
  //       source: '人民日报',
  //       content: '新华社北京11月8日电（记者 李宣良、张玉清）七十载光辉岁月，九万里风鹏正举。在人民空军成立70周年之际，中共中央总书记、国家主席、中央军委主席习近平8日出席庆祝空军成立70周年主题活动，代表党中央和中央军委，对空军成立70周年表示热烈祝贺，向空军全体官兵致以诚挚问候。'
  //     }
  //   ]
  // },
  // {
  //   title: '行业动态',
  //   logoImg: '/static/img/logo',
  //   type: 'gov',
  //   rule: '采集行业动态数据，包含标题、时间、内容、来源等字段。 采集地址：http://www.ynta.gov.cn/Category_1049/Index_1.aspx',
  //   modelType: 13,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '时间',
  //       key: 'createTime',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '来源',
  //       key: 'source',
  //       fieldIds: 3
  //     },
  //     {
  //       name: '内容',
  //       key: 'content',
  //       fieldIds: 4
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: '创新指数何以创新高',
  //       link: 'http://www.whyn.gov.cn/list/index/1/1',
  //       createTime: '2019-11-01 09:00',
  //       source: '人民日报',
  //       content: '新华社北京11月8日电（记者 李宣良、张玉清）七十载光辉岁月，九万里风鹏正举。在人民空军成立70周年之际，中共中央总书记、国家主席、中央军委主席习近平8日出席庆祝空军成立70周年主题活动，代表党中央和中央军委，对空军成立70周年表示热烈祝贺，向空军全体官兵致以诚挚问候。'
  //     }
  //   ]
  // },
  // {
  //   title: '州市动态',
  //   logoImg: '/static/img/logo',
  //   type: 'gov',
  //   rule: '采集州市动态数据，包含标题、时间、内容、来源等字段。 采集地址：http://www.ynta.gov.cn/Category_972/Index_1.aspx',
  //   modelType: 14,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '时间',
  //       key: 'createTime',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '来源',
  //       key: 'source',
  //       fieldIds: 3
  //     },
  //     {
  //       name: '内容',
  //       key: 'content',
  //       fieldIds: 4
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: '创新指数何以创新高',
  //       link: 'http://www.whyn.gov.cn/list/index/1/1',
  //       createTime: '2019-11-01 09:00',
  //       source: '人民日报',
  //       content: '新华社北京11月8日电（记者 李宣良、张玉清）七十载光辉岁月，九万里风鹏正举。在人民空军成立70周年之际，中共中央总书记、国家主席、中央军委主席习近平8日出席庆祝空军成立70周年主题活动，代表党中央和中央军委，对空军成立70周年表示热烈祝贺，向空军全体官兵致以诚挚问候。'
  //     }
  //   ]
  // },
  // {
  //   title: '通知公告',
  //   logoImg: '/static/img/logo',
  //   type: 'gov',
  //   rule: '采集通知公告数据，包含标题、时间、内容、来源等字段。 采集地址：http://www.ynta.gov.cn/Category_984/Index_1.aspx',
  //   modelType: 15,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '时间',
  //       key: 'createTime',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '来源',
  //       key: 'source',
  //       fieldIds: 3
  //     },
  //     {
  //       name: '内容',
  //       key: 'content',
  //       fieldIds: 4
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: '创新指数何以创新高',
  //       link: 'http://www.whyn.gov.cn/list/index/1/1',
  //       createTime: '2019-11-01 09:00',
  //       source: '人民日报',
  //       content: '新华社北京11月8日电（记者 李宣良、张玉清）七十载光辉岁月，九万里风鹏正举。在人民空军成立70周年之际，中共中央总书记、国家主席、中央军委主席习近平8日出席庆祝空军成立70周年主题活动，代表党中央和中央军委，对空军成立70周年表示热烈祝贺，向空军全体官兵致以诚挚问候。'
  //     }
  //   ]
  // },
  // {
  //   title: '政策法规',
  //   logoImg: '/static/img/logo',
  //   type: 'gov',
  //   rule: '采集政策法规数据，包含标题、时间、内容、来源等字段。 采集地址：http://www.whyn.gov.cn/list/index/3/1',
  //   modelType: 16,
  //   tableTile: [
  //     {
  //       name: '标题',
  //       key: 'title',
  //       fieldIds: 1
  //     },
  //     {
  //       name: '时间',
  //       key: 'createTime',
  //       fieldIds: 2
  //     },
  //     {
  //       name: '来源',
  //       key: 'source',
  //       fieldIds: 3
  //     },
  //     {
  //       name: '内容',
  //       key: 'content',
  //       fieldIds: 4
  //     }
  //   ],
  //   exampleList: [
  //     {
  //       title: '创新指数何以创新高',
  //       link: 'http://www.whyn.gov.cn/list/index/1/1',
  //       createTime: '2019-11-01 09:00',
  //       source: '人民日报',
  //       content: '新华社北京11月8日电（记者 李宣良、张玉清）七十载光辉岁月，九万里风鹏正举。在人民空军成立70周年之际，中共中央总书记、国家主席、中央军委主席习近平8日出席庆祝空军成立70周年主题活动，代表党中央和中央军委，对空军成立70周年表示热烈祝贺，向空军全体官兵致以诚挚问候。'
  //     }
  //   ]
  // }
]

export default FastCollectData
